module.exports = __webpack_public_path__ + "img/5_wgoods.f8a392f5.jpg";